<template>
  <div :class="bem()">
    <input :value="value" @input="input" :placeholder="placeholder" />
  </div>
</template>
<script>
import create from '../create'
export default create({
  name: 'input',
  props: {
    placeholder: '',
    value: ''
  },
  methods: {
    input() {
      console.log(11)
    }
  }
})
</script>

<style lang="scss" src="./index.scss"></style>
